import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const ShippingSettingsModal = ({ isOpen, onClose, company, onSettingsUpdated }) => {
  const [settings, setSettings] = useState({
    is_visible_to_customers: true,
    kdv_rate: 20.00,
    commission_rate: 0.00,
    commission_type: 'percentage',
    min_order_amount: 0.00,
    max_order_amount: null,
    priority_order: 0,
    is_active: true,
    notes: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [loadingSettings, setLoadingSettings] = useState(false);
  const [logoUploading, setLogoUploading] = useState(false);
  const [logoFile, setLogoFile] = useState(null);

  // Modal açıldığında en güncel ayarları yükle
  useEffect(() => {
    if (isOpen && company) {
      // LocalStorage'dan logo URL'ini yükle
      const logoKey = `shipping_company_logo_${company.id}`;
      const savedLogoUrl = localStorage.getItem(logoKey);
      if (savedLogoUrl && !company.logo_url) {
        console.log('📱 LocalStorage\'dan logo yüklendi:', savedLogoUrl);
        company.logo_url = savedLogoUrl;
      }
      
      loadCurrentSettings();
    }
  }, [isOpen, company]);

  // En güncel ayarları API'den çek
  const loadCurrentSettings = async () => {
    try {
      setLoadingSettings(true);
      setError('');
      
      console.log('🔄 En güncel ayarlar API\'den çekiliyor...', company.id);
      const response = await api.get(`/api/shipping-companies/${company.id}`);
      
      console.log('📡 API Response:', response);
      
      if (response.success && response.data) {
        const companyData = response.data;
        console.log('🏢 API\'den gelen şirket verileri:', companyData);
        console.log('⚙️ Shipping company settings array:', companyData.shipping_company_settings);
        
        // shipping_company_settings array veya object olabilir
        let currentSettings = {};
        if (Array.isArray(companyData.shipping_company_settings)) {
          currentSettings = companyData.shipping_company_settings[0] || {};
        } else if (companyData.shipping_company_settings) {
          currentSettings = companyData.shipping_company_settings;
        }
        console.log('📋 Çıkarılan ayarlar objesi:', currentSettings);
        console.log('💰 KDV Rate (raw):', currentSettings.kdv_rate, typeof currentSettings.kdv_rate);
        console.log('💼 Commission Rate (raw):', currentSettings.commission_rate, typeof currentSettings.commission_rate);
        
        const newSettings = {
          is_visible_to_customers: currentSettings.is_visible_to_customers !== false,
          kdv_rate: currentSettings.kdv_rate !== undefined && currentSettings.kdv_rate !== null ? parseFloat(currentSettings.kdv_rate) : 20.00,
          commission_rate: currentSettings.commission_rate !== undefined && currentSettings.commission_rate !== null ? parseFloat(currentSettings.commission_rate) : 0.00,
          commission_type: currentSettings.commission_type || 'percentage',
          min_order_amount: currentSettings.min_order_amount !== undefined ? parseFloat(currentSettings.min_order_amount) : 0.00,
          max_order_amount: currentSettings.max_order_amount !== undefined && currentSettings.max_order_amount !== null ? parseFloat(currentSettings.max_order_amount) : null,
          priority_order: currentSettings.priority_order !== undefined ? parseInt(currentSettings.priority_order) : 0,
          is_active: currentSettings.is_active !== false,
          notes: currentSettings.notes || ''
        };
        
        console.log('✅ Yeni settings objesi:', newSettings);
        console.log('💰 KDV Rate (processed):', newSettings.kdv_rate);
        console.log('💼 Commission Rate (processed):', newSettings.commission_rate);
        
        setSettings(newSettings);
      } else {
        // Fallback: Mevcut company verisini kullan
        console.log('⚠️ API\'den veri alınamadı, mevcut company verisini kullanıyor...');
        console.log('🏢 Fallback company data:', company);
        
        // Fallback için de aynı kontrol
        let currentSettings = {};
        if (Array.isArray(company.shipping_company_settings)) {
          currentSettings = company.shipping_company_settings[0] || {};
        } else if (company.shipping_company_settings) {
          currentSettings = company.shipping_company_settings;
        }
        console.log('📋 Fallback settings:', currentSettings);
        
        const fallbackSettings = {
          is_visible_to_customers: currentSettings.is_visible_to_customers !== false,
          kdv_rate: currentSettings.kdv_rate !== undefined && currentSettings.kdv_rate !== null ? parseFloat(currentSettings.kdv_rate) : 20.00,
          commission_rate: currentSettings.commission_rate !== undefined && currentSettings.commission_rate !== null ? parseFloat(currentSettings.commission_rate) : 0.00,
          commission_type: currentSettings.commission_type || 'percentage',
          min_order_amount: currentSettings.min_order_amount !== undefined ? parseFloat(currentSettings.min_order_amount) : 0.00,
          max_order_amount: currentSettings.max_order_amount !== undefined && currentSettings.max_order_amount !== null ? parseFloat(currentSettings.max_order_amount) : null,
          priority_order: currentSettings.priority_order !== undefined ? parseInt(currentSettings.priority_order) : 0,
          is_active: currentSettings.is_active !== false,
          notes: currentSettings.notes || ''
        };
        
        console.log('✅ Fallback settings objesi:', fallbackSettings);
        setSettings(fallbackSettings);
      }
    } catch (error) {
      console.error('❌ Ayarlar yüklenirken hata:', error);
      setError('Ayarlar yüklenemedi: ' + error.message);
    } finally {
      setLoadingSettings(false);
    }
  };

  // Form değişikliklerini handle et
  const handleChange = (field, value) => {
    setSettings(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Ayarları kaydet
  const saveSettings = async () => {
    try {
      setLoading(true);
      setError('');

      console.log('Ayarlar kaydediliyor:', settings);
      const response = await api.put(`/api/shipping-companies/settings/${company.id}`, settings);
      console.log('Ayar kaydetme yanıtı:', response);

      if (response.success) {
        // Ayarlar kaydedildikten sonra fiyat hesaplamalarını tetikle
        try {
          console.log('Fiyat hesaplamaları tetikleniyor...');
          await api.post('/api/shipping-companies/recalculate-prices');
          console.log('Fiyat hesaplamaları tamamlandı');
        } catch (recalcError) {
          console.warn('Fiyat hesaplama hatası:', recalcError);
          // Fiyat hesaplama hatası olsa bile ayarlar kaydedildi
        }
        
        // Önce callback'i çağır (listeyi yenile)
        if (onSettingsUpdated) {
          console.log('🔄 Şirket listesi yenileniyor...');
          await onSettingsUpdated();
          console.log('✅ Şirket listesi yenilendi');
        }
        
        // Modal'ı kapat (bekleme olmadan)
        onClose();
      } else {
        setError('Ayarlar kaydedilemedi');
      }
    } catch (error) {
      console.error('Ayarlar kaydedilirken hata:', error);
      setError(error.message || 'Ayarlar kaydedilemedi');
    } finally {
      setLoading(false);
    }
  };

  // Logo yükleme fonksiyonu - Supabase Storage kullanarak
  const uploadLogo = async () => {
    if (!logoFile) return null;

    try {
      setLogoUploading(true);
      const formData = new FormData();
      formData.append('logo', logoFile);

      console.log('📤 Logo Supabase Storage\'a yükleniyor...');

      const response = await api.post('/api/logo/upload-logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log('📤 Logo upload response:', response);

      if (response.success) {
        console.log('✅ Logo başarıyla Supabase Storage\'a yüklendi:', response.data.logo_url);
        console.log('📊 Storage bilgileri:', response.data);
        
        // Başarı mesajı göster
        if (window.toast) {
          window.toast.success('Logo başarıyla yüklendi ve kalıcı olarak saklandı!');
        }
        
        return response.data.logo_url;
      } else {
        throw new Error(response.error || 'Logo yüklenemedi');
      }
    } catch (error) {
      console.error('❌ Logo yükleme hatası:', error);
      throw error;
    } finally {
      setLogoUploading(false);
    }
  };

  // Logo seçme fonksiyonu
  const handleLogoSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Dosya boyutu kontrolü (2MB)
      if (file.size > 2 * 1024 * 1024) {
        setError('Logo dosyası 2MB\'dan küçük olmalıdır');
        return;
      }
      
      // Dosya tipi kontrolü
      if (!file.type.startsWith('image/')) {
        setError('Sadece resim dosyaları kabul edilir');
        return;
      }

      setLogoFile(file);
      setError('');
      console.log('📁 Logo dosyası seçildi:', file.name);
    }
  };

  // Ayarları kaydet (logo ile birlikte)
  const saveSettingsWithLogo = async () => {
    try {
      setLoading(true);
      setError('');

      let logoUrl = company.logo_url; // Mevcut logo URL'i

      // Eğer yeni logo seçildiyse önce onu yükle
      if (logoFile) {
        console.log('📤 Yeni logo yükleniyor...');
        logoUrl = await uploadLogo();
        console.log('✅ Logo yüklendi, URL:', logoUrl);
      }

      console.log('🔧 Ayarlar kaydediliyor:', settings);
      const response = await api.put(`/api/shipping-companies/settings/${company.id}`, settings);
      console.log('📋 Ayar kaydetme yanıtı:', response);

      // Logo URL'ini veritabanına kaydet
      if (logoUrl && logoUrl !== company.logo_url) {
        console.log('🖼️ Logo URL\'i veritabanına kaydediliyor...');
        console.log('🔗 Kaydedilecek logo URL:', logoUrl);
        console.log('🏢 Şirket ID:', company.id);
        
        try {
          // Şirket bilgilerini güncelle (logo URL dahil)
          const logoUpdateResponse = await api.put(`/api/shipping-companies/${company.id}`, {
            logo_url: logoUrl
          });
          
          console.log('📊 Logo güncelleme yanıtı:', logoUpdateResponse);
          
          if (logoUpdateResponse.success) {
            console.log('✅ Logo veritabanına başarıyla kaydedildi');
            
            // LocalStorage'a da kaydet (cache için)
            const logoKey = `shipping_company_logo_${company.id}`;
            localStorage.setItem(logoKey, logoUrl);
            console.log('💾 Logo localStorage\'a da kaydedildi:', logoKey);
            
            // Company objesini güncelle
            company.logo_url = logoUrl;
            console.log('✅ Local company objesi güncellendi, yeni logo_url:', company.logo_url);
            
            // Global state'i güncelle (eğer varsa)
            if (window.shippingCompaniesCache) {
              const companyIndex = window.shippingCompaniesCache.findIndex(c => c.id === company.id);
              if (companyIndex !== -1) {
                window.shippingCompaniesCache[companyIndex].logo_url = logoUrl;
                console.log('🌐 Global cache güncellendi');
              }
            }
            
            console.log('🎉 Logo başarıyla veritabanına kaydedildi!');
          } else {
            console.error('❌ Logo veritabanına kaydedilemedi:', logoUpdateResponse);
            setError('Logo kaydedilemedi: ' + (logoUpdateResponse.error || 'Bilinmeyen hata'));
          }
        } catch (logoError) {
          console.error('❌ Logo güncelleme hatası:', logoError);
          setError('Logo kaydedilemedi: ' + logoError.message);
        }
      }

      if (response.success) {
        // Ayarlar kaydedildikten sonra fiyat hesaplamalarını tetikle
        try {
          console.log('🔄 Fiyat hesaplamaları tetikleniyor...');
          await api.post('/api/shipping-companies/recalculate-prices');
          console.log('✅ Fiyat hesaplamaları tamamlandı');
        } catch (recalcError) {
          console.warn('⚠️ Fiyat hesaplama hatası:', recalcError);
          // Fiyat hesaplama hatası olsa bile ayarlar kaydedildi
        }
        
        // Önce callback'i çağır (listeyi yenile)
        if (onSettingsUpdated) {
          console.log('🔄 Şirket listesi yenileniyor...');
          await onSettingsUpdated();
          console.log('✅ Şirket listesi yenilendi');
        }
        
        // Kısa bir bekleme sonrası modal'ı kapat (listenin güncellenmesi için)
        setTimeout(() => {
          onClose();
        }, 1000);
      } else {
        setError('Ayarlar kaydedilemedi');
      }
    } catch (error) {
      console.error('❌ Ayarlar kaydedilirken hata:', error);
      setError(error.message || 'Ayarlar kaydedilemedi');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !company) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
        {/* Modal Header */}
        <div className="bg-gradient-to-r from-green-500 to-blue-600 text-white p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {company.logo_url ? (
                <img 
                  src={company.logo_url} 
                  alt={company.name}
                  className="w-12 h-12 rounded-lg object-contain bg-white p-2"
                />
              ) : (
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
              )}
              <div>
                <h2 className="text-2xl font-bold">{company.name}</h2>
                <p className="text-green-100">Kargo Ayarları</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-200"
            >
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Modal Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
          {loadingSettings && (
            <div className="flex items-center justify-center py-8">
              <svg className="animate-spin h-8 w-8 text-blue-600 mr-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span className="text-gray-600">En güncel ayarlar yükleniyor...</span>
            </div>
          )}
          
          {error && (
            <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-6 rounded-r-xl">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-red-700">{error}</p>
                </div>
              </div>
            </div>
          )}

          <div className="space-y-6">
            {/* Logo Yükleme Alanı */}
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-xl border border-purple-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <svg className="w-6 h-6 mr-2 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Şirket Logosu
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Mevcut Logo Gösterimi */}
                <div className="text-center">
                  <div className="w-32 h-32 mx-auto bg-white rounded-xl border-2 border-dashed border-gray-300 flex items-center justify-center mb-3">
                    {company.logo_url ? (
                      <img 
                        src={company.logo_url} 
                        alt={`${company.name} Logo`}
                        className="w-full h-full object-contain rounded-lg"
                      />
                    ) : (
                      <div className="text-center">
                        <svg className="w-12 h-12 text-gray-400 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <p className="text-sm text-gray-500">Mevcut Logo Yok</p>
                      </div>
                    )}
                  </div>
                  <p className="text-sm text-gray-600">Mevcut Logo</p>
                </div>

                {/* Yeni Logo Yükleme */}
                <div className="text-center">
                  <div className="w-32 h-32 mx-auto bg-white rounded-xl border-2 border-dashed border-purple-300 flex items-center justify-center mb-3 relative overflow-hidden">
                    {logoFile ? (
                      <img 
                        src={URL.createObjectURL(logoFile)} 
                        alt="Yeni Logo Önizleme"
                        className="w-full h-full object-contain rounded-lg"
                      />
                    ) : (
                      <div className="text-center">
                        <svg className="w-12 h-12 text-purple-400 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                        </svg>
                        <p className="text-sm text-purple-500">Yeni Logo</p>
                      </div>
                    )}
                  </div>
                  
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleLogoSelect}
                    disabled={loadingSettings || logoUploading}
                    className="hidden"
                    id="logo-upload"
                  />
                  <label
                    htmlFor="logo-upload"
                    className="inline-flex items-center px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 cursor-pointer transition-colors disabled:opacity-50"
                  >
                    {logoUploading ? (
                      <>
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Yükleniyor...
                      </>
                    ) : (
                      <>
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                        </svg>
                        Logo Seç
                      </>
                    )}
                  </label>
                  
                  {logoFile && (
                    <div className="mt-2">
                      <p className="text-xs text-green-600 font-medium">{logoFile.name}</p>
                      <button
                        onClick={() => setLogoFile(null)}
                        className="text-xs text-red-500 hover:text-red-700 mt-1"
                      >
                        Kaldır
                      </button>
                    </div>
                  )}
                </div>
              </div>
              
              <div className="mt-4 text-center">
                <p className="text-xs text-gray-500">
                  • Maksimum dosya boyutu: 2MB<br/>
                  • Desteklenen formatlar: JPG, PNG, GIF, SVG<br/>
                  • Önerilen boyut: 200x200 piksel
                </p>
              </div>
            </div>

            {/* Görünürlük Ayarları */}
            <div className="bg-blue-50 rounded-xl p-4">
              <h3 className="text-lg font-semibold text-blue-800 mb-4 flex items-center">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                Görünürlük Ayarları
              </h3>
              
              <div className="grid grid-cols-2 gap-4">
                <label className="flex items-center space-x-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={settings.is_visible_to_customers}
                    onChange={(e) => handleChange('is_visible_to_customers', e.target.checked)}
                    className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                  <span className="text-sm font-medium text-gray-700">Müşterilere Görünür</span>
                </label>
                
                <label className="flex items-center space-x-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={settings.is_active}
                    onChange={(e) => handleChange('is_active', e.target.checked)}
                    className="rounded border-gray-300 text-green-600 focus:ring-green-500"
                  />
                  <span className="text-sm font-medium text-gray-700">Aktif</span>
                </label>
              </div>
            </div>

            {/* Finansal Ayarlar */}
            <div className="bg-green-50 rounded-xl p-4">
              <h3 className="text-lg font-semibold text-green-800 mb-4 flex items-center">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Finansal Ayarlar
              </h3>
              
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">KDV Oranı (%)</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    value={settings.kdv_rate}
                    onChange={(e) => handleChange('kdv_rate', parseFloat(e.target.value) || 0)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="20.00"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Komisyon ({settings.commission_type === 'percentage' ? '%' : '₺'})
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={settings.commission_rate}
                    onChange={(e) => handleChange('commission_rate', parseFloat(e.target.value) || 0)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="0.00"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Komisyon Tipi</label>
                <select
                  value={settings.commission_type}
                  onChange={(e) => handleChange('commission_type', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                >
                  <option value="percentage">Yüzde (%)</option>
                  <option value="fixed">Sabit Tutar (₺)</option>
                </select>
              </div>
            </div>

            {/* Diğer Ayarlar */}
            <div className="bg-gray-50 rounded-xl p-4">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100-4m0 4v2m0-6V4" />
                </svg>
                Diğer Ayarlar
              </h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Öncelik Sırası</label>
                  <input
                    type="number"
                    min="0"
                    value={settings.priority_order}
                    onChange={(e) => handleChange('priority_order', parseInt(e.target.value) || 0)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="0 (düşük sayı = yüksek öncelik)"
                  />
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Min. Sipariş (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={settings.min_order_amount}
                      onChange={(e) => handleChange('min_order_amount', parseFloat(e.target.value) || 0)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="0.00"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Max. Sipariş (₺)</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      value={settings.max_order_amount || ''}
                      onChange={(e) => handleChange('max_order_amount', e.target.value ? parseFloat(e.target.value) : null)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Sınırsız"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Notlar</label>
                  <textarea
                    value={settings.notes}
                    onChange={(e) => handleChange('notes', e.target.value)}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Yönetici notları..."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="bg-gray-50 px-6 py-4 flex justify-end space-x-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-6 py-2 bg-gray-500 text-white rounded-lg font-semibold hover:bg-gray-600 transition-all duration-200 disabled:opacity-50"
          >
            İptal
          </button>
          <button
            onClick={saveSettingsWithLogo}
            disabled={loading || logoUploading}
            className="px-6 py-2 bg-gradient-to-r from-green-500 to-blue-600 text-white rounded-lg font-semibold hover:from-green-600 hover:to-blue-700 transition-all duration-200 disabled:opacity-50"
          >
            {loading || logoUploading ? (
              <>
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                {logoUploading ? 'Logo Yükleniyor...' : 'Kaydediliyor & Hesaplanıyor...'}
              </>
            ) : (
              <>
                <svg className="w-5 h-5 mr-2 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Kaydet & Logo Güncelle
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShippingSettingsModal;